// @flow

import 'whatwg-fetch'
import { baseFetch } from '.'
import { API_TAGS } from '../urls'

export async function getAllTags() {
  const response = await baseFetch(API_TAGS)
  const data = await response.json()
  return data.results
}



// WEBPACK FOOTER //
// ./src/fetch/tags.js